"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.2
  });
  return <section id="calltoaction" ref={ref} className="relative overflow-hidden h-[500px] flex items-center justify-center ![padding:0px_24px_0px_24px]">
    {}
    <div className="absolute inset-0 bg-[#8b6e4c]" />

    {}
    <div className="relative max-w-4xl w-full text-center">
      <h2 className="font-display font-bold mb-6 text-5xl transition-all duration-700 opacity-100 translate-y-0 !text-[hsl(0,0%,100%)]">Planning Your Own Renovation?</h2>

      <p className="mb-10 max-w-2xl mx-auto leading-relaxed text-base transition-all duration-700 delay-100 opacity-100 translate-y-0 !text-[hsl(0,0%,100%)]">Let <span className="font-semibold">KS LUXURY RENOVATIONS</span> transform your vision into a refined, expertly executed space.</p>

      <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Link to="https://ksluxury.cloudtech.com.cy/get-a-quote/" newTab>
          <Button size="lg" className="text-white px-10 py-6 text-lg font-semibold rounded-full shadow-strong transition-all hover:-translate-y-1 !bg-[hsl(35,48%,55%)]">
            Request a Consultation
          </Button>
        </Link>

        <Link to="/Contact" className="mb-8 sm:mb-0">
          <Button size="lg" className="bg-secondary text-foreground-secondary px-10 py-6 text-lg font-semibold rounded-full shadow-strong hover:-translate-y-1 transition-all">
            Contact Us
          </Button>
        </Link>
      </div>
    </div>
  </section>;
}